// Copyright (c) Docugami, Inc. All rights reserved.
import React from 'react';
import styled from 'styled-components';
import { DgNonSelectableLabelCss, DgVerticalSpacer } from '../common/DgCommonStyledComponents';
import { ServerSideRedirect } from './AaTaskpaneMenu';
import { PrimaryButton } from "@fluentui/react";
import { Config } from '../../config';
import { dgFontFamily } from 'components/common/Fonts';
import { primaryTheme } from 'components/shell/presentation/AppStyles';


const TaglineText = styled.span`
    font-family: ${dgFontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    ${DgNonSelectableLabelCss}
    color: ${primaryTheme.palette.black};
`;

const SupportMessage = styled.span`
    font-family: ${dgFontFamily};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    ${DgNonSelectableLabelCss}
    color: ${primaryTheme.palette.black};
`;

const ImagePlaceholder = styled.div`
    height: 130px;
    width: 191px;
`;

const PanelLayout = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: ${primaryTheme.palette.white};
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
`;

export const AaUnknownDocumentMessage = (): JSX.Element => {
    return <PanelLayout>
        <DgVerticalSpacer height="29px" key="vp0"/>
        <div style={{width: "280px", textAlign: "center"}}>
            <TaglineText>Welcome to Docugami, the Document Engineering Company!</TaglineText>
        </div>
        <DgVerticalSpacer height="39px" key="vp1"/>
        <ImagePlaceholder key="image">
            <img src='assets/unknownDocument.png' alt='Unknown Document'/>
        </ImagePlaceholder>
        <DgVerticalSpacer height="46px" key="vp2"/>
        <SupportMessage>We haven't seen a document like this from you before. We'd love to understand it and improve your productivity, please upload more examples of it via our web app.</SupportMessage>
        <DgVerticalSpacer height="28px" key="vp3"/>
        <PrimaryButton onClick={ () => ServerSideRedirect(Config.baseUrl) } className="loginButton">
            LAUNCH WEB APP
        </PrimaryButton>
    </PanelLayout>
}
